// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".courseSearch .searchArearow {\n  margin-bottom: 20px !important;\n}\n.courseSearch .searchArearow .lblvalue {\n  height: auto !important;\n}", ""]);
// Exports
module.exports = exports;
